

















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import AdminChangelogInnerTableModal from '@/modules/changelog/components/admin/AdminChangelogInnerTableModal.vue'
import { Prop } from 'vue-property-decorator'
import { isDef } from '@/modules/shared/helpers/utils/utils'

@Component
export default class AdminChangelogInnerTableCell extends Vue {
  @Prop({ required: true }) changelog!: any

  private get isSimpleData() {
    return ['number', 'string', 'boolean'].includes(typeof this.changelog) || !isDef(this.changelog)
  }

  private get stringifyChangelog() {
    return JSON.stringify(this.changelog) || 'undefined'
  }

  private get stringifyChangelogClass() {
    switch (typeof this.changelog) {
      case 'number':
      case 'boolean':
        return 'text-tes-green'
      case 'string':
        return 'text-indigo'
      default:
        return 'text-tes-purple'
    }
  }

  private showModal() {
    this.$q.dialog({
      component: AdminChangelogInnerTableModal,
      changelog: this.changelog
    })
  }
}
